import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Format number as Swiss currency: 1'234.56 CHF */
export function formatCHF(amount: number, currency = 'CHF'): string {
  if (!Number.isFinite(amount)) return `0.00 ${currency}`
  const formatted = amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'")
  return `${formatted} ${currency}`
}
